
import ArticleInfoBaseTemplate from './ArticleInfoBaseTemplate';
import ArticleInfoTags from '@root/views/article/components/info/ArticleInfoTags.vue';
import CustomerStateHandler from '@customer/components/CustomerStateHandler.vue';
import ArticleInfoSocial from '@root/views/article/components/info/ArticleInfoSocial.vue';

export default ArticleInfoBaseTemplate.extend({
  components: {
    ArticleInfoSocial,
    CustomerStateHandler,
    ArticleInfoTags,
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },
    title() {
      return this.$props.article.content.title.html
        ? this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '')
        : this.$props.article.content.title.text;
    },
    commentsNoBrackets() {
      const { commentsNoBrackets } = this.$channelConfig('settings');
      return commentsNoBrackets;
    },
  },
});
